import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { XCircle, Mail, LogOut } from 'lucide-react';
import { logger } from '../utils/logger';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AccessDisabledPage({ user, onLogout }) {
  const handleLogout = async () => {
    try {
      await fetch(`${API_URL}/api/auth/logout`, {
        method: 'POST',
        credentials: 'include'
      });
      if (onLogout) onLogout();
    } catch (error) {
      logger.error('Logout error:', error);
      if (onLogout) onLogout();
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="access-disabled-page">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
            <XCircle className="w-8 h-8 text-red-600" />
          </div>
          <CardTitle className="text-xl font-heading">Access Disabled</CardTitle>
          <CardDescription className="mt-2">
            Your account has been disabled by an administrator.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-slate-100 rounded-lg p-4 text-center">
            <p className="text-sm text-slate-600">Account</p>
            <p className="font-medium text-slate-900">{user?.name}</p>
            <p className="text-sm text-slate-500">{user?.email}</p>
          </div>
          
          <div className="bg-red-50 border border-red-200 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <Mail className="w-5 h-5 text-red-600 mt-0.5" />
              <div className="text-sm">
                <p className="font-medium text-red-800">Need help?</p>
                <p className="text-red-700 mt-1">
                  If you believe this is an error, please contact your administrator to restore access.
                </p>
              </div>
            </div>
          </div>

          <Button 
            variant="outline" 
            className="w-full" 
            onClick={handleLogout}
            data-testid="logout-btn"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Sign Out
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
